import OfferEvent from '@core/models/offer/OfferEvent';
import { getConfig } from '@superbet-group/web.lib.config';
import {
    differenceInCalendarDays,
    differenceInMinutes,
} from '@superbet-group/web.lib.utilities';
import { TimeFilter } from './types';
import dayTimeFilters from './dayTimeFilters';

// duplicated from helpers.ts beacause the file where the function is imported from
// cant have i18n import in it if you want to write tests for it.
function getTimeFilterForWeekDay(dayIndex: number) {
    return dayTimeFilters[dayIndex];
}

export function getTimeFilterFromEvent(event: OfferEvent): TimeFilter {
    const todaysDate = new Date();
    const todayTimeFilter = getTimeFilterForWeekDay(todaysDate.getDay());
    let eventTimeFilter = getTimeFilterForWeekDay(event.date.getDay());
    const isInFuture = differenceInCalendarDays(todaysDate, event.date)
        > getConfig().app.sportOffer.gridDateFutureThreshold;
    const isInPast = differenceInMinutes(event.date, todaysDate) < 0;
    const isUpcoming = differenceInMinutes(event.date, todaysDate) <= 180;

    if (event.isOngoing()) {
        return TimeFilter.Live;
    }
    if (isInFuture || isInPast) {
        return TimeFilter.All;
    }
    if (isUpcoming) {
        return TimeFilter.Upcoming;
    }
    if (todayTimeFilter === eventTimeFilter) {
        return TimeFilter.Today;
    }
    return eventTimeFilter;
}
